import { render, staticRenderFns } from "./multi-account-owner.vue?vue&type=template&id=22a33a2e"
import script from "./multi-account-owner.vue?vue&type=script&lang=js"
export * from "./multi-account-owner.vue?vue&type=script&lang=js"
import style0 from "./multi-account-owner.vue?vue&type=style&index=0&id=22a33a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports